// extracted by mini-css-extract-plugin
module.exports = {"green":"BidTableItem_green__3p7zp","yellow":"BidTableItem_yellow__21W2B","grey":"BidTableItem_grey__1uh4_"};